import React, { Component } from 'react';
import { connect } from 'dva';
import './myFollowed.less';
import ABSPanel from '../../../../../components/ABSPanel';
import ABSLink from '../../../../../components/ABSLink';
import routeConfig from '../../../../config/routeConfig';
import ABSExpertList from '../../../../../components/ABSExpertList';
import ABSFollowProduct from '../../../../../components/ABSFollowProduct';
import { getABSFollowProductData } from '../../../../../components/ABSFollowProduct/utils';
export interface IABSMyFollowedProps {
  dispatch: any;
  homeDynamicExperts: any;
  homeFollowProduct: any;
  homeMessage: any;
  isLogin: boolean;
}

class MyFollowed extends Component<IABSMyFollowedProps> {
  componentDidMount() {
    const { isLogin } = this.props;
    if (isLogin) {
      this.props.dispatch({type: 'home/getHomeFollowProduct', payload: { page_size: -1 }});
      this.props.dispatch({ type: 'home/getHomeDnamicExperts' });
      this.props.dispatch({ type: 'home/getHomeMessages' });
    }
  }

  addMoreBtn() {
    return (
      <ABSLink target="_blank" to={routeConfig.followDeal}>更多</ABSLink>
    );
  }

  renderProductEmptyText() {
    return (
      <>
        前往<ABSLink target="_blank" to={routeConfig.productList}>产品列表</ABSLink>关注更多产品
      </>
    );
  }

  renderExpertsEmptyText() {
    return (
      <>
        前往<ABSLink target="_blank" to={routeConfig.expertSquare}>专家广场</ABSLink>关注行业专家
      </>
    );
  }

  renderMessageEmptyText() {
    return (
      <>
        暂无<ABSLink target="_blank" to={routeConfig.internalMessage}>站内消息</ABSLink>
      </>
    );
  }
  render() {
    const { homeDynamicExperts, homeFollowProduct, homeMessage } = this.props;
    const newFollowProduct = getABSFollowProductData(homeFollowProduct);
    return (
      <div className="abs-home-right-my-follow">
        <ABSPanel 
          title="我关注的" 
          comment={this.addMoreBtn()} 
          hasBorder={false} 
          removePadding={true} 
          isClearBackground={true}
        >
          <ABSFollowProduct followData={newFollowProduct} emptyText={this.renderProductEmptyText()}/>
          <ABSExpertList 
            experts={homeDynamicExperts} 
            emptyText={this.renderExpertsEmptyText()} 
            isShowNextAction={true} 
          />
          <div className="abs-home-right-my-follow-message">
            <ABSExpertList 
              experts={homeMessage} 
              emptyText={this.renderMessageEmptyText()} 
              isShowNextAction={true} 
              isHasMessage={true} 
            />
          </div>
        </ABSPanel>
      </div>
    );
  }
}

function mapStateToProps({ home }: any) {
  const { homeDynamicExperts, homeFollowProduct, homeMessage  } = home;
  return { homeDynamicExperts, homeFollowProduct, homeMessage };
}

export default connect(mapStateToProps)(MyFollowed); 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/right/myFollowed.tsx